/* eslint-disable react-hooks/exhaustive-deps */

import { WrapperCtx } from "App/Component/layout/Wrapper/context/context";
import { BILLING_INPUT_TAGIHAN } from "App/constants";
import { isNull } from "App/utils/helpers";
import React, { createContext, useEffect, useState, useContext } from "react";
import { RESET_STATE_INPUT_TAGIHAN } from "../ui";

export const FormContext = createContext();

export const FormProvider = ({ children }) => {
  const { state } = useContext(WrapperCtx);
  const [formError, setFormError] = useState(null);
  const [dataPaket, setDataPaket] = useState([]);
  const [formData, setFormData] = useState(() => {
    if (isNull(state.page_input_tagihan)) {
      return RESET_STATE_INPUT_TAGIHAN;
    } else {
      if (state.wrapper_active_menu === BILLING_INPUT_TAGIHAN) {
        return state.page_input_tagihan;
      } else {
        return RESET_STATE_INPUT_TAGIHAN;
      }
    }
  });

  useEffect(() => {
    if (isNull(state.page_input_tagihan)) {
      setFormData(RESET_STATE_INPUT_TAGIHAN);
    } else {
      if (state.wrapper_active_menu === BILLING_INPUT_TAGIHAN) {
        setFormData(state.page_input_tagihan);
      } else {
        setFormData(RESET_STATE_INPUT_TAGIHAN);
      }
    }
  }, [state.page_input_tagihan]);

  return (
    <FormContext.Provider
      value={{ formData, setFormData, formError, setFormError,dataPaket, setDataPaket }}>
      {children}
    </FormContext.Provider>
  );
};
